import autocomplete from 'autocomplete.js';
import locationSearchAdapterMethods from './locationSearchAdapterMethods';

export default {
    data() {
        return {
            autocomplete: null,
            query: '',
            hits: 5,
            locationSearchAdapter: null,
        };
    },
    watch: {
        value() {
            if (this.value) {
                this.query = this.value.name;
            }
        },
        query() {
            if (!this.query) {
                this.$emit('input', null);
            }
        },
    },
    methods: Object.assign({}, locationSearchAdapterMethods, {
        parseLocationDetails(location) {
            const regExp = new RegExp(`(${this.query})`, 'gi');

            let countryName = location.country.name;
            let countryDataName = '';

            if (location.country.localisations && typeof location.country.localisations[this.locale] !== 'undefined') {
                countryName = location.country.localisations[this.locale].name;
            }

            if (location.country && location.country.data) {
                if (typeof location.country.data === 'string') {
                    countryDataName = location.country.data;
                } else if (location.country.data.name) {
                    countryDataName = location.country.data.name;
                }
            }

            return [
                location.county ? location.county.replace(regExp, '<em>$1</em>') : '',
                countryDataName ? countryDataName.replace(regExp, '<em>$1</em>') : '',
                location.country && location.country ? countryName.replace(regExp, '<em>$1</em>') : '',
            ]
                .filter((entry) => entry && entry.trim() != '')
                .join(', ');
        },
        highlightQuery(location) {
            let name = location.name;
            if (typeof location.localisations[this.locale] !== 'undefined') {
                name = location.localisations[this.locale].name;
            }
            if (this.isIe) {
                return name;
            }

            const regExp = new RegExp(`(${this.query})`, 'gi');

            return name.replace(regExp, '<em>$1</em>');
        },
    }),
    computed: {
        pickupLocation: {
            get() {
                return this.$store.state.search.search.pickupLocation;
            },
        },
        locationSources() {
            if (!this.searchProviders) {
                return 'provider:WoS';
            } else if (typeof this.searchProviders == 'string') {
                return 'provider:' + this.searchProviders;
            } else if (Array.isArray(this.searchProviders) && this.searchProviders.length > 0) {
                return this.searchProviders.map((x) => `provider:${x}`).join(' OR ');
            }

            return 'provider:WoS';
        },
        locationFilters() {
            return this.locationSources;
        },
    },
    mounted() {
        if (!this.autocomplete) {
            this.autocomplete = autocomplete(
                this.$refs.locationSearch,
                {
                    autoselect: true,
                    autoselectOnBlur: true,
                    templates: {
                        dropdownMenu: '#location-search-template',
                        empty: '<div>' + this.noResultsLabel + '</div>',
                    },
                },
                [
                    {
                        source: this.locationSearchSource(),
                        name: 'd1',
                        displayKey: 'name',
                        templates: {
                            suggestion: (suggestion) => {
                                return `
                                  <div class="aa-suggestion-location">
                                    <span>${this.highlightQuery(suggestion)}</span>
                                  </div>
                                  <div class="aa-suggestion-extra-details">
                                    <span>${this.parseLocationDetails(suggestion)}</span>
                                  </div>
                                `;
                            },
                        },
                    },
                ]
            ).on('autocomplete:selected', (event, suggestion, dataset) => {
                this.$store.dispatch('setPickupLocation', suggestion);
                this.$emit('locationSearch.pickUpLocation', suggestion);
                this.$emit('input', suggestion);
            });

            if (this.pickupLocationId) {
                this.loadInitialLocation(this.pickupLocationId);
            } else if (this.value) {
                this.loadInitialLocation(this.value.id);
            }
        }
    },
};
